import React, { useContext, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Redirect,
  RouteProps,
  Route,
} from 'react-router-dom';

import './App.scss';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import styles from './App.module.scss';

import {
  ADMIN_URL, IS_DEV,
} from './lib/config';

import MainLayout from './components/layout/MainLayout';
import CourseEditLayout from './components/layout/CourseEditLayout';
import { AuthContext } from './modules/auth';

import { ErrorContext } from './components/organisms/ModalError/context';

const InvalidRoute: React.FC<RouteProps> = () => {
  // for local development fallback to default values.
  if (IS_DEV) {
    return <Redirect to="/1/lms" />;
  }

  window.location.assign(ADMIN_URL);
  return <div>redirecting</div>;
};

const CheckUserAccess: React.FC<RouteProps> = (props) => {
  const { appDetailsState } = useContext(AuthContext);
  const { loading, error, data } = appDetailsState;
  const { setError } = useContext(ErrorContext);

  useEffect(() => {
    if (error) {
      setError({
        error,
        description: error.message,
      });
    }
  }, [error, setError]);

  if (loading) {
    return <div>loading...</div>;
  }

  if (error || !data) {
    return <div/>;
  }

  // if no errors then proceed to the route
  return <Route {...props} />;
};

const ProtectedRoute: React.FC<RouteProps> = (props) => {
  return <CheckUserAccess {...props}/>;
};

const App: React.FC<{}> = () => {
  const props: any = {
    className: styles.layout,
  };
  return (
    <Router>
      <Switch>
        <ProtectedRoute path="/:appId/:serviceName/course/:courseId">
          <DndProvider backend={HTML5Backend}>
            <CourseEditLayout {...props}/>
          </DndProvider>
        </ProtectedRoute>
        <ProtectedRoute path="/:appId/:serviceName">
          <MainLayout {...props}/>
        </ProtectedRoute>
        <InvalidRoute path="/" />
      </Switch>
    </Router>
  );
};

export default App;
